module.exports = __webpack_public_path__ + "img/globe.7a41e09c.svg";